module.exports = __webpack_public_path__ + "static/media/ice-cool3@3x.21d165d2.png";